var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TagsApi } from "../../core/api/tagsApi";
import { APPEND_TAGS_SUCCESS, CLEAR_TAGS, GET_TAGS_SUCCESS } from "./types";
export const getTags = (params) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const page = yield TagsApi.list(params);
    dispatch({ type: GET_TAGS_SUCCESS, payload: page });
    return page;
});
export const getMoreTags = (params) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const page = yield TagsApi.list(params);
    dispatch({ type: APPEND_TAGS_SUCCESS, payload: page });
    return page;
});
export const clearTags = () => ({ type: CLEAR_TAGS });
